import React from 'react';
import PropTypes from 'prop-types';

const CopyHtml = ({
  html,
  tag: Tag = 'p',
  className,
  ...props
}) => {
  if (!html) {
    return null;
  }

  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  );
};

CopyHtml.propTypes = {
  html: PropTypes.string,
  tag: PropTypes.string,
  className: PropTypes.string,
};

CopyHtml.defaultProps = {
  html: '',
  tag: 'p',
  className: '',
};

export default CopyHtml;
